module.exports = __webpack_public_path__ + "media/images/lb/009-7ce41e1463e9c44ecf5ae1bd8e39d74d.svg";